export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <path d="M7 29V14a9 9 0 0 1 18 0v15" stroke="currentColor" strokeWidth="2" />
    <path d="M16 6v23M7 20h18" stroke="currentColor" strokeWidth="2" />
    <circle cx="20.5" cy="24.5" r="1.6" fill="#B5794B" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-[1.65rem] leading-none tracking-tight">Borcelle</span>
  </span>
);
